import React, { useEffect } from 'react';
import { CheckCircleIcon, DownloadIcon, SparklesIcon } from 'lucide-react';
export function ThankYouPage() {
  useEffect(() => {
    // Track Purchase event cuando carga la página
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Purchase', {
        content_name: 'Guía TikTok Shop',
        content_category: 'Digital Product',
        content_ids: ['guia-tiktok-shop'],
        content_type: 'product',
        value: 190,
        currency: 'MXN',
        num_items: 1
      });
    }
  }, []);
  return <div className="min-h-screen bg-gradient-premium flex items-center justify-center p-4" data-id="element-582">
      <div className="max-w-2xl w-full" data-id="element-583">
        {/* Success Icon */}
        <div className="text-center mb-8 animate-fade-in" data-id="element-584">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-accent-success rounded-full mb-6 shadow-large animate-bounce" data-id="element-585">
            <CheckCircleIcon className="w-12 h-12 text-white" data-id="element-586" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-black text-deep-cocoa mb-3" data-id="element-587">
            ¡Felicidades! 🎉
          </h1>
          <p className="text-xl text-deep-cocoa/80 font-semibold" data-id="element-588">
            Tu compra fue exitosa
          </p>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-premium p-6 sm:p-8 mb-6 animate-fade-in-up" data-id="element-589">
          <div className="space-y-6" data-id="element-590">
            {/* Confirmation Message */}
            <div className="bg-accent-success/10 rounded-xl p-5 border border-accent-success/20" data-id="element-591">
              <p className="text-deep-cocoa leading-relaxed" data-id="element-592">
                <strong className="text-accent-success" data-id="element-593">
                  ¡Bienvenida a la comunidad!
                </strong>{' '}
                Has dado el primer paso para generar ingresos extra con TikTok
                Shop. Tu guía completa está lista.
              </p>
            </div>

            {/* Next Steps */}
            <div data-id="element-594">
              <h2 className="text-xl font-black text-deep-cocoa mb-4 flex items-center gap-2" data-id="element-595">
                <SparklesIcon className="w-6 h-6 text-cta-primary" data-id="element-596" />
                Próximos pasos:
              </h2>

              <div className="space-y-4" data-id="element-597">
                {/* Step 1 */}
                <div className="flex items-start gap-4 p-4 bg-almond-milk rounded-xl" data-id="element-598">
                  <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-cta-primary to-cta-secondary rounded-full flex items-center justify-center text-white font-bold shadow-soft" data-id="element-599">
                    1
                  </div>
                  <div className="flex-1" data-id="element-600">
                    <h3 className="font-bold text-deep-cocoa mb-1" data-id="element-601">
                      Revisa tu correo electrónico
                    </h3>
                    <p className="text-sm text-deep-cocoa/70" data-id="element-602">
                      Te enviamos un email con el acceso a la guía completa (PDF
                      + Videos). Revisa tu bandeja de entrada y spam.
                    </p>
                  </div>
                </div>

                {/* Step 2 */}
                <div className="flex items-start gap-4 p-4 bg-almond-milk rounded-xl" data-id="element-603">
                  <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-cta-primary to-cta-secondary rounded-full flex items-center justify-center text-white font-bold shadow-soft" data-id="element-604">
                    2
                  </div>
                  <div className="flex-1" data-id="element-605">
                    <h3 className="font-bold text-deep-cocoa mb-1" data-id="element-606">
                      Descarga tu guía
                    </h3>
                    <p className="text-sm text-deep-cocoa/70 mb-3" data-id="element-607">
                      Accede a todo el contenido: sistema paso a paso, 50
                      scripts de video, plantillas de Canva y más.
                    </p>
                    <a href="mailto:soporte@tiktokshopmx.com" className="inline-flex items-center gap-2 text-sm font-bold text-cta-primary hover:text-cta-hover transition-colors" data-id="element-608">
                      <DownloadIcon className="w-4 h-4" data-id="element-609" />
                      ¿No recibiste el email? Contáctanos
                    </a>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="flex items-start gap-4 p-4 bg-almond-milk rounded-xl" data-id="element-610">
                  <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-cta-primary to-cta-secondary rounded-full flex items-center justify-center text-white font-bold shadow-soft" data-id="element-611">
                    3
                  </div>
                  <div className="flex-1" data-id="element-612">
                    <h3 className="font-bold text-deep-cocoa mb-1" data-id="element-613">
                      Empieza hoy mismo
                    </h3>
                    <p className="text-sm text-deep-cocoa/70" data-id="element-614">
                      Sigue el sistema paso a paso. Muchas mujeres hacen su
                      primera venta en los primeros 7 días. ¡Tú puedes ser la
                      siguiente!
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Support */}
            <div className="border-t border-deep-cocoa/10 pt-6" data-id="element-615">
              <h3 className="font-bold text-deep-cocoa mb-3" data-id="element-616">
                ¿Necesitas ayuda?
              </h3>
              <p className="text-sm text-deep-cocoa/70 mb-3" data-id="element-617">
                Estamos aquí para apoyarte en cada paso. Si tienes alguna duda o
                problema, contáctanos:
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-618">
                <a href="mailto:soporte@tiktokshopmx.com" className="text-sm font-semibold text-cta-primary hover:text-cta-hover transition-colors" data-id="element-619">
                  📧 soporte@tiktokshopmx.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial */}
        <div className="bg-white rounded-xl shadow-soft p-5 animate-fade-in-up" style={{
        animationDelay: '200ms'
      }} data-id="element-620">
          <p className="text-sm text-deep-cocoa/80 italic mb-3" data-id="element-621">
            "En mi primera semana ya había ganado $847 pesos. La guía es super
            clara, paso a paso. Ahora gano más de $12,000 al mes."
          </p>
          <div className="flex items-center gap-3" data-id="element-622">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" alt="María González" width="40" height="40" className="w-10 h-10 rounded-full object-cover shadow-soft" data-id="element-623" />
            <div data-id="element-624">
              <div className="font-bold text-deep-cocoa text-sm" data-id="element-625">
                María González
              </div>
              <div className="text-xs text-deep-cocoa/60" data-id="element-626">CDMX</div>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-xs text-deep-cocoa/60 mt-6" data-id="element-627">
          Gracias por confiar en nosotros. ¡Estamos emocionados de verte
          triunfar! 🚀
        </p>
      </div>
    </div>;
}